import cn from 'classnames';

import { constructMSAImageUrl } from 'helpers';
import css from 'styles/components/common/melodyCardTwoCol.scss';
import LandingPageLink from 'components/landing/LandingPageLink';
import CrossSiteLabel from 'components/common/melodyCard/CrossSiteLabel';

const defaultMsaParams = { height: 400, width: 400, autoCrop: true };

const MelodyCardTwoCol = props => {
  const {
    className,
    store,
    msaImageId,
    imageId,
    noLink,
    link,
    url,
    alt,
    price,
    brandName,
    productName,
    name,
    styleColor,
    msaParams = defaultMsaParams
  } = props;

  const altString = alt === '' ? alt : alt || styleColor || productName || name;

  return (
    <LandingPageLink
      url={noLink ? null : (link || url)}
      className={cn(css.container, { [css.noLink]: noLink }, className)}
      fallbackNode="div">
      <div className={css.imgContainer}>
        <img src={constructMSAImageUrl(imageId || msaImageId, msaParams)} alt={altString} />
      </div>
      <div className={css.content}>
        {store && <CrossSiteLabel store={store}/>}
        {productName && <p className={css.brand}>{brandName}</p>}
        {productName && <p className={css.product}>{productName}</p>}
        {price && <p className={css.price}>{price}</p>}
      </div>
    </LandingPageLink>
  );
};

export default MelodyCardTwoCol;
